import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DatePipeModule } from '../date/date.module';

import { SectorComponent } from './sector.component';
import { SeatClassPipe } from './seat.pipe';
import { CarbonFootprintModule } from 'libraries/component/carbon-footprint/carbon-footprint.module';
import { LanguageService } from "libraries/service/language/language.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";


@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
        CarbonFootprintModule,
        FontAwesomeModule
    ],
    declarations: [
        SectorComponent,
        SeatClassPipe,
    ],
    exports: [
        SectorComponent,
        SeatClassPipe,
    ],
    providers: [
        LanguageService
    ]
})
export class SectorModule {
}
